/* eslint-disable import/prefer-default-export */
import { createContext } from 'react';

const StaffPayslipContext = createContext({});
export default StaffPayslipContext;
